// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AppRole,
} from "./types";


export default __t.row({
  userId: __t.string().primaryKey().name("user_id"),
  stdbIdentity: __t.string().name("stdb_identity"),
  workosSub: __t.string().name("workos_sub"),
  email: __t.string(),
  displayName: __t.string().name("display_name"),
  get appRole() {
    return AppRole.name("app_role");
  },
  occupation: __t.string(),
  addedAt: __t.timestamp().name("added_at"),
  firstConnectedAt: __t.timestamp().name("first_connected_at"),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
